var url = process.env.API_URL + process.env.API_VERSION;
import axios from 'axios';
import cookie from 'vue-cookie';

const state  = {
	list_counselors: [],
  pagination: {}
}

const mutations = {
	SET_LIST_COUNSELORS(state, data){
    state.list_counselors = data.counselors    
    state.pagination = data.pagination
  }
}

const actions = {
  load_list_counselors({commit}, page) {
    axios.get(url + "/users/get_list_counselors?page=" + page,
      {
        headers:{
              'Authorization': cookie.get('user-token') || ''
            }
      })
      .then((response) =>{        
        commit('SET_LIST_COUNSELORS', response.data.extra)
      })
  },
}
const getters = {

}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/counselors.js